import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { PART_REPOSITORY } from "@partikelart/parts/data-access-core";
import type { Part } from "@partikelart/parts/domain";
import { DEFAULT_PARTS, DemoPartRepository } from "./demo-part.repository";

/**
 * Provides {@link DemoPartRepository} as the {@link PART_REPOSITORY} implementation,
 * so the parts state feature can run fully offline against an in-memory store.
 *
 * @example
 * ```ts
 * // app.config.ts (demo build)
 * import { provideDemoPartRepository } from "@partikelart/parts/data-access-demo";
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideDemoPartRepository(),
 *     // ...other providers
 *   ],
 * };
 * ```
 */
export function provideDemoPartRepository(seed?: Part[]): EnvironmentProviders {
	return makeEnvironmentProviders([
		{
			provide: PART_REPOSITORY,
			useFactory: () => new DemoPartRepository(seed ?? DEFAULT_PARTS),
		},
	]);
}
